import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "../src/assets/css/style.css";
import store from "./store";
import { auth } from "./firebase";
import "animate.css";
import VueSocketIO from "vue-socket.io";

Vue.config.productionTip = false;

global.jq = require("jquery");
var $ = global.jq;
window.$ = $;
window.jQuery = $;
window.dt = require("datatables.net-bs4");

Vue.use(
  new VueSocketIO({
    debug: true,
    connection: "http://bachirapp.herokuapp.com/",
    vuex: {
      store,
      actionPrefix: "SOCKET_",
      mutationPrefix: "SOCKET_",
    },
  })
);

let app;
auth.onAuthStateChanged(() => {
  if (!app) {
    new Vue({
      router,
      store,
      render: (h) => h(App),
    }).$mount("#app");
  }
});
